import { memo } from 'react'
import { ButtonBase, SxProps } from '@mui/material'
import { BookSeatsIcon, BookSeatsLogo, ChevronLeftThin, ChevronRightThick } from '@/assets'
import { Box } from '@/components/Layout'
import { useTranslations } from '@/core/translation'
import { sidebarClasses } from '../SidebarLayout.data'
import { sidebarLayoutStyles as layoutStyles } from '../SidebarLayout.style'
import { sidebarBrandStyles as styles } from './SidebarBrand.style'
import { SidebarBrandProps } from './SidebarBrand.types'

/**
 * The panel's first row, and the one control that opens and closes it. Collapsed,
 * the mark's own slot is the control; expanded, the wordmark reads out and a
 * chevron sits at the panel's edge. The mark holds one size and one position
 * throughout.
 */
function SidebarBrand({ showLabel, onToggle }: SidebarBrandProps) {
  const t = useTranslations('sidebar')

  return (
    <Box sx={styles.row}>
      {showLabel ? (
        <>
          <Box sx={styles.lockupSlot}>
            <Box component={BookSeatsLogo} sx={styles.lockup} />
          </Box>
          <ButtonBase
            sx={[layoutStyles.iconButton, styles.collapseButton] as SxProps}
            onClick={onToggle}
            aria-label={t('collapse')}>
            <Box component={ChevronLeftThin} sx={layoutStyles.iconButtonIcon} />
          </ButtonBase>
        </>
      ) : (
        <ButtonBase
          sx={[styles.slot, styles.slotToggle] as SxProps}
          onClick={onToggle}
          aria-label={t('expand')}
          title={t('expand')}>
          <Box component={BookSeatsIcon} className={sidebarClasses.brandMark} sx={styles.mark} />
          <Box
            component={ChevronRightThick}
            className={sidebarClasses.brandToggle}
            sx={styles.toggleGlyph}
          />
        </ButtonBase>
      )}
    </Box>
  )
}

export default memo(SidebarBrand)
